module.exports = __webpack_public_path__ + "static/2020中国新经济企业活力100指数榜-abc9508aad5eec9586359a83c2a2caa1.jpg";